import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=5b9919fa"
import script from "./PublicLayout.vue?vue&type=script&lang=js"
export * from "./PublicLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports